import React, { useContext } from 'react';

import { Grow } from '@material-ui/core';
import { removeTaskAction, addNewTaskAction, fetchTasksAction } from 'actions/task';
import Task1 from 'models/task1';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { selectAddToAgendaState } from 'selectors/addToAgendaStateSelector';

import NoTasksImage from 'assets/images/illustrations/no_initiatives.png';

import { TASK_TYPES_2, MESH_LIST_TABS } from 'constants/ProjectConstants';
import { sendTaskEvent, TASK_EVENTS } from 'constants/mixpanelHelper';

import { showTaskDetails } from 'services/taskDetails';

import MeshListContext from '../MeshListContext';
import TasksGoalsContainer from '../TasksGoalsContainer';
import NewTaskListItem from './NewTaskListItem';
import NoTasksComponent from './NoTasksComponent';
import TaskListItem from './TaskListItem';

export default function Tasks({ tasks, pageType, employee }) {
  const { selectedTab, dispatch, apiPaginationMeta, selectedTeamsPageView = null } = useContext(MeshListContext);

  const { showAddToAgenda } = useSelector(selectAddToAgendaState, shallowEqual);

  const reduxDispatch = useDispatch();

  const showDetails = (e, taskId, type) => {
    if (e) e.stopPropagation();
    reduxDispatch(
      showTaskDetails({
        taskIds: [taskId],
        onDelete: () => {
          dispatch(removeTaskAction(taskId));
        },
        onUpdate: (task) => {
          dispatch(fetchTasksAction({ pageType, employeeId: employee.id }));
        },
        employee,
        type,
      })
    );

    sendTaskEvent({ pageType, eventName: TASK_EVENTS.openedSidePanel, referrer: 'MeshList' });
  };

  const isTasksTabSelected = selectedTab === MESH_LIST_TABS.task.id || selectedTeamsPageView === TASK_TYPES_2.task;

  const createNewTaskHandler = () => {
    dispatch(
      addNewTaskAction({
        employee: { ...employee, ownerType: Task1.EMPLOYEE_TYPES.owner },
        selectedTeamId: null,
      })
    );
  };

  const onNewTaskCreate = () => {
    dispatch(fetchTasksAction({ pageType, employeeId: employee.id }));
  };

  if (tasks?.length === 0 && isTasksTabSelected) {
    return (
      <NoTasksComponent
        img={NoTasksImage}
        heading="No initiatives yet"
        subHeading="Use Initiatives to plan your activities and achieve results here."
        onButtonClick={createNewTaskHandler}
        buttonText="Add Initiative"
      />
    );
  }

  return isTasksTabSelected ? (
    <TasksGoalsContainer>
      {tasks.map((task, index, taskArray) => {
        const lastItem = index + 1 === taskArray.length;
        const taskId = task?.id ?? task?.uuid;
        return !taskId && task.isEditing ? (
          <Grow in key={`activeTasks${task.id || task.key}`}>
            <NewTaskListItem
              key={`newTask${task.key}`}
              task={task}
              pageType={pageType}
              onNewTaskCreate={onNewTaskCreate}
            />
          </Grow>
        ) : (
          <Grow style={{ marginBottom: lastItem ? '70px' : 0 }} in key={`activeTasks${taskId || task.key}`}>
            <TaskListItem
              key={`task${taskId}`}
              task={task}
              onClickHandler={(e) => showDetails(e, taskId, task.type)}
              showAddToAgenda={showAddToAgenda}
            />
          </Grow>
        );
      })}
      {/* {apiPaginationMeta?.hasMore && (
        <div>
          <Box
            position={'absolute'}
            bottom={0}
            width={'100%'}
            borderTop={'1px solid lightgrey'}
            textAlign={'center'}
          >
            <LoadMore type={TASK_TYPES_2.task} pageType={pageType} />
          </Box>
        </div>
      )} */}
    </TasksGoalsContainer>
  ) : null;
}
